import React, { useState } from 'react';
import './ConsultationForm.css';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';

function ConsultationForm() {
  const { language } = useLanguage();
  const t = translations[language];

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    ailment: ''
  });
  const [status, setStatus] = useState('idle'); // idle, submitting, success, error

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');

    try {
      const response = await fetch('https://formspree.io/f/meeeglyw', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          phone: formData.phone,
          ailment: formData.ailment,
          _subject: `New Consultation Request from ${formData.name}`
        })
      });

      if (response.ok) {
        setStatus('success');
        setFormData({ name: '', phone: '', ailment: '' });
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="ConsultationForm">
      <h2 className="consultation-title">{t.requestConsultation}</h2>

      {status === 'success' ? (
        <div className="form-message success">
          {t.formSuccess}
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="consultation-form">
          <div className="form-group">
            <label htmlFor="name">{t.patientName}</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder={t.patientNamePlaceholder}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">{t.contactNumber}</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder={t.contactNumberPlaceholder}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="ailment">{t.ailmentSummary}</label>
            <textarea
              id="ailment"
              name="ailment"
              value={formData.ailment}
              onChange={handleChange}
              placeholder={t.ailmentSummaryPlaceholder}
              rows="4"
              required
            />
          </div>

          {status === 'error' && (
            <div className="form-message error">
              {t.formError}
            </div>
          )}

          <button type="submit" disabled={status === 'submitting'}>
            {status === 'submitting' ? t.formSubmitting : t.submitRequest}
          </button>
        </form>
      )}
    </div>
  );
}

export default ConsultationForm;
